<div [formGroup]="config" class="menu">
  <app-change-number [formControl]="childrenCount"
    >Ilość dzieci
  </app-change-number>
  <app-change-number formControlName="itemsPerRow"
    >Ilość dzieci w wierszu
  </app-change-number>

  <mat-form-field libZalamoField>
    <mat-select formControlName="align">
      <mat-option value="center">Do środka</mat-option>
      <mat-option value="left">Do lewej</mat-option>
      <mat-option value="right">Do prawej</mat-option>
    </mat-select>
    <lib-zalamo-field-decoration></lib-zalamo-field-decoration
  ></mat-form-field>
  @if (config.value.itemsPerRow % 2 === 0) {
    <lib-checkbox formControlName="addSpine">Dodaj grzbiet</lib-checkbox>
    @if (config.value.addSpine) {
      <app-change-number formControlName="spineSize" [minNumber]="0"
        >Rozmiar grzbietu
      </app-change-number>
    }
  }
  <app-change-number formControlName="sideMargin" [minNumber]="0" [step]="10"
    >Boczne marginesy
  </app-change-number>
  <app-change-number formControlName="childVerticalMargin" [minNumber]="0"
    >Odstęp między dziećmi w poziomie
  </app-change-number>
  <app-change-number formControlName="childHorizontalMargin" [minNumber]="0"
    >Odstęp między dziećmi w pionie
  </app-change-number>

  <h3>Pojedyńcze dziecko</h3>
  <mat-form-field libZalamoField>
    <mat-label> Wyświetlaine imienia i nazwiska</mat-label>
    <mat-select formControlName="nameHandling">
      <mat-option value="split">
        Imię i nazwisko w osobnych wierszach
      </mat-option>

      <mat-option value="join"> Imię i nazwisko w jednym wierszu</mat-option>
    </mat-select>
    <lib-zalamo-field-decoration></lib-zalamo-field-decoration
  ></mat-form-field>
  <app-change-number
    formControlName="childFirstNameMaxFontSize"
    [minNumber]="10"
    >Maksymalny rozmiar czcionki imienia
  </app-change-number>

  <app-change-number formControlName="childFirstNameHeight" [minNumber]="10"
    >Wysokośc pola na imię
  </app-change-number>
  <app-change-number formControlName="childLastNameHeight" [minNumber]="10"
    >Wysokośc pola na nazwisko
  </app-change-number>
  <app-change-number formControlName="childNamesGap" [minNumber]="0"
    >Odstęp między imieniem a nazwiskiem
  </app-change-number>
  <app-change-number formControlName="childTilt" [minNumber]="0"
    >Losowe obrócenie dziecka
  </app-change-number>
  <app-change-number formControlName="childPositionDistortion" [minNumber]="0"
    >Losowe przesunięcie dziecka
  </app-change-number>

  <app-change-number formControlName="childNameTilt" [minNumber]="0"
    >Losowe obrócenie tabliczki z nazwiskiem
  </app-change-number>

  <app-change-number formControlName="childLastNameMaxFontSize" [minNumber]="10"
    >Maksymalny rozmiar czcionki nazwiska
  </app-change-number>
  <app-change-number formControlName="photoRadius" [minNumber]="0"
    >Zaokrąglone rogi zdjęcia
  </app-change-number>
  @if (!config.value.photoAsSquare) {
    <lib-checkbox formControlName="photoAsCircle"
      >Zdjęcie jako okrąg
    </lib-checkbox>
  }
  @if (!config.value.photoAsCircle) {
    <lib-checkbox formControlName="photoAsSquare"
      >Zdjęcie jako kwadrat
    </lib-checkbox>
  }
  <app-change-number formControlName="childPhotoNameToPhotoGap" [minNumber]="0">
    Odstęp między zdjęciem a imieniem i nazwiskiem
  </app-change-number>
  <mat-form-field libZalamoField>
    <mat-label>Różnicuj wygląd dzieci</mat-label>

    <mat-select formControlName="childConfigDifferenceRule">
      <mat-option value="none">Nie różnicuj</mat-option>

      <mat-option value="oddEven">Parzyste/nieparzyste</mat-option>
      <mat-option value="oddEvenRow">Parzyste/nieparzyste rzędy</mat-option>
    </mat-select>
    <lib-zalamo-field-decoration></lib-zalamo-field-decoration
  ></mat-form-field>
  @if (
    config.value.childConfigDifferenceRule === 'oddEven' ||
    config.value.childConfigDifferenceRule === 'oddEvenRow'
  ) {
    <h3>Nieparzyste:</h3>
    <ng-container
      *ngTemplateOutlet="childConfig; context: { mode: 'Odd' }"
    ></ng-container>
    <h3>Parzyste:</h3>
    <ng-container
      *ngTemplateOutlet="childConfig; context: { mode: 'Even' }"
    ></ng-container>
  }
  @if (config.value.childConfigDifferenceRule === 'none') {
    <ng-container
      *ngTemplateOutlet="childConfig; context: { mode: '' }"
    ></ng-container>
  }
  <ng-template #childConfig let-mode="mode">
    <app-change-number
      formControlName="childFrameWidth{{ mode }}"
      [minNumber]="0"
      >Grubość ramki wokół dziecka
    </app-change-number>
    <app-change-number formControlName="childRadius{{ mode }}" [minNumber]="0"
      >Zaokrąglone rogi dziecka
    </app-change-number>
    <lib-box-shadow-editor formControlName="childShadow{{ mode }}">
      Cieniowanie dziecka
    </lib-box-shadow-editor>
    @if (config.value['childFrameWidth' + mode]) {
      <div class="colorPicker">
        Kolor ramki:
        <input
          #me
          (colorPickerChange)="
            config.controls['childFrameColor' + mode].patchValue($event)
          "
          [cpUseRootViewContainer]="true"
          [(colorPicker)]="config.value['childFrameColor' + mode]"
          [style.background]="
            me.value ? me.value : config.value['childFrameColor' + mode]
          "
        />
      </div>
    }
    <div class="colorPicker">
      Kolor tła dla dziecka
      <input
        #me
        (colorPickerChange)="
          config.controls['childBackgroundColor' + mode].patchValue($event)
        "
        [cpUseRootViewContainer]="true"
        [(colorPicker)]="config.value['childBackgroundColor' + mode]"
        [style.background]="
          me.value ? me.value : config.value['childBackgroundColor' + mode]
        "
      />
    </div>
    <app-change-number
      formControlName="childPhotoFrameWidth{{ mode }}"
      [minNumber]="0"
    >
      Grubość ramki wokół zdjęcia
    </app-change-number>
    @if (config.value['childPhotoFrameWidth' + mode]) {
      <div class="colorPicker">
        Kolor ramki:
        <input
          #me
          (colorPickerChange)="
            config.controls['childPhotoFrameColor' + mode].patchValue($event)
          "
          [cpUseRootViewContainer]="true"
          [(colorPicker)]="config.value['childPhotoFrameColor' + mode]"
          [style.background]="
            me.value ? me.value : config.value['childPhotoFrameColor' + mode]
          "
        />
      </div>
    }
    <app-change-number
      formControlName="photoSideMargins{{ mode }}"
      [minNumber]="0"
      >Marginesy boczne zdjęcia
    </app-change-number>

    <app-change-number
      formControlName="childNameFrameWidth{{ mode }}"
      [minNumber]="0"
    >
      Grubość ramki woków imienia i nazwiska
    </app-change-number>
    @if (config.value['childNameFrameWidth' + mode]) {
      <div class="colorPicker">
        Kolor ramki wokól imienia i nazwiska:
        <input
          #me
          (colorPickerChange)="
            config.controls['childNameNameFrameColor' + mode].patchValue($event)
          "
          [cpUseRootViewContainer]="true"
          [(colorPicker)]="config.value['childNameNameFrameColor' + mode]"
          [style.background]="
            me.value ? me.value : config.value['childNameNameFrameColor' + mode]
          "
        />
      </div>
    }
    @if (config.value['childNameFrameWidth' + mode]) {
      <app-change-number
        formControlName="childNameFrameRadius{{ mode }}"
        [minNumber]="0"
        >Zaokrąglone rogi wokół imienia i nazwiska
      </app-change-number>
    }
    <app-change-number
      formControlName="childNameSideMargins{{ mode }}"
      [minNumber]="0"
    >
      Marginesy boczne imienia i nazwiska
    </app-change-number>
    <div class="colorPicker">
      Kolor czcionki imienia i nazwiska:
      <input
        #me
        (colorPickerChange)="
          config.controls['childPhotoNameFontColor' + mode].patchValue($event)
        "
        [cpUseRootViewContainer]="true"
        [(colorPicker)]="config.value['childPhotoNameFontColor' + mode]"
        [style.background]="
          me.value ? me.value : config.value['childPhotoNameFontColor' + mode]
        "
      />
    </div>
    <div class="colorPicker">
      Kolor tła dla imienia i nazwiska:
      <input
        #me
        (colorPickerChange)="
          config.controls['childNameBackgroundColor' + mode].patchValue($event)
        "
        [cpUseRootViewContainer]="true"
        [(colorPicker)]="config.value['childNameBackgroundColor' + mode]"
        [style.background]="
          me.value ? me.value : config.value['childNameBackgroundColor' + mode]
        "
      />
    </div>
  </ng-template>
</div>

<div class="ctn">
  @if (namesListenerRegistered$ | async) {
    <div class="content">
      <img src="/assets/local-tests/tablo.png" />
      <ngx-moveable
        (drag)="onDrag($event)"
        (resize)="onResize($event)"
        [draggable]="true"
        [edge]="false"
        [keepRatio]="false"
        [origin]="false"
        [pinchable]="false"
        [resizable]="true"
        [rotatable]="false"
        [scalable]="true"
        [target]="children"
        [throttleDrag]="0"
        [throttleResize]="0"
        [throttleRotate]="0"
        [throttleScale]="0"
      ></ngx-moveable>
      <div
        class="children"
        #children
        [ngStyle]="{
          'justify-content': config.value.align,
          'margin-left.px': config.value.sideMargin,
          'margin-right.px': config.value.sideMargin,
        }"
      >
        @for (
          name of names$ | async;
          track name;
          let i = $index;
          let c = $count
        ) {
          <ng-container>
            @let nameType = name.type;

            @switch (nameType) {
              @case ('empty') {
                <div
                  class="spine"
                  [ngStyle]="{
                    'width.px': config.value.spineSize,
                    'height.%': itemHeight$ | async,
                  }"
                ></div>
              }
              @case ('placeholder') {
                <div
                  class="placeholder"
                  [ngStyle]="{
                    width:
                      'calc(' +
                      (itemWidth$ | async) +
                      ' * ' +
                      name.placeHolderSize +
                      ')',
                    'height.%': itemHeight$ | async,
                    'z-index': c - i,
                  }"
                >
                  <lib-button (click)="removePlaceholder(name.index)"
                    >Usuń</lib-button
                  >
                </div>
              }
              @case ('child') {
                <div
                  mat-button
                  class="child"
                  [ngStyle]="{
                    width: itemWidth$ | async,
                    'height.%': itemHeight$ | async,
                    'padding-left.px': config.value.childHorizontalMargin,
                    'padding-right.px': config.value.childHorizontalMargin,
                    'padding-top.px': config.value.childVerticalMargin,
                    'padding-bottom.px': config.value.childVerticalMargin,

                    'z-index': c - i,
                    transform:
                      'translateX(' +
                      name.childPositionDistortion.x +
                      'px) translateY(' +
                      name.childPositionDistortion.y +
                      'px) rotate(' +
                      name.childTilt +
                      'deg)',
                    'transform-origin':
                      name.childOriginTransform.x +
                      '% ' +
                      name.childOriginTransform.y +
                      '%',
                  }"
                  [ngClass]="{
                    isEmpty: name.isEmpty,
                  }"
                >
                  <div
                    class="border"
                    [matMenuTriggerFor]="menu"
                    [ngStyle]="{
                      'border-width.px':
                        config.value
                        | getRightElementValue
                          : 'childFrameWidth'
                          : name.index
                          : name.row,
                      'border-color':
                        config.value
                        | getRightElementValue
                          : 'childFrameColor'
                          : name.index
                          : name.row,
                      'gap.px': config.value.childPhotoNameToPhotoGap,
                      'box-shadow':
                        config.value
                        | getRightElementValue
                          : 'childShadow'
                          : name.index
                          : name.row,
                      'background-color':
                        config.value
                        | getRightElementValue
                          : 'childBackgroundColor'
                          : name.index
                          : name.row,
                      'border-radius.px':
                        config.value
                        | getRightElementValue
                          : 'childRadius'
                          : name.index
                          : name.row,
                    }"
                  >
                    <div
                      class="photo"
                      [ngClass]="{
                        circle: config.value.photoAsCircle,
                      }"
                      [ngStyle]="{
                        'padding-left.px':
                          config.value
                          | getRightElementValue
                            : 'photoSideMargins'
                            : name.index
                            : name.row,
                        'padding-right.px':
                          config.value
                          | getRightElementValue
                            : 'photoSideMargins'
                            : name.index
                            : name.row,
                      }"
                    >
                      <img
                        src=""
                        [ngStyle]="{
                          'border-radius.px':
                            config.value
                            | getRightElementValue
                              : 'photoRadius'
                              : name.index
                              : name.row,
                          'border-width.px':
                            config.value
                            | getRightElementValue
                              : 'childPhotoFrameWidth'
                              : name.index
                              : name.row,
                          'border-color':
                            config.value
                            | getRightElementValue
                              : 'childPhotoFrameColor'
                              : name.index
                              : name.row,
                          width:
                            'calc(100% - 2 * ' +
                            (config.value
                              | getRightElementValue
                                : 'photoSideMargins'
                                : name.index
                                : name.row) +
                            'px)',
                        }"
                      />
                    </div>
                    <div
                      class="name"
                      [ngStyle]="{
                        'gap.px': config.value.childNamesGap,
                        'border-color':
                          config.value
                          | getRightElementValue
                            : 'childNameNameFrameColor'
                            : name.index
                            : name.row,
                        'border-width.px':
                          config.value
                          | getRightElementValue
                            : 'childNameFrameWidth'
                            : name.index
                            : name.row,
                        color:
                          config.value
                          | getRightElementValue
                            : 'childPhotoNameFontColor'
                            : name.index
                            : name.row,
                        'background-color':
                          config.value
                          | getRightElementValue
                            : 'childNameBackgroundColor'
                            : name.index
                            : name.row,
                        'padding-left.px':
                          config.value
                          | getRightElementValue
                            : 'childNameSideMargins'
                            : name.index
                            : name.row,
                        'padding-right.px':
                          config.value
                          | getRightElementValue
                            : 'childNameSideMargins'
                            : name.index
                            : name.row,
                        'border-radius.px':
                          config.value
                          | getRightElementValue
                            : 'childNameFrameRadius'
                            : name.index
                            : name.row,
                        transform: 'rotate(' + name.nameTilt + 'deg)',
                      }"
                    >
                      @if (config.value.nameHandling === 'split') {
                        <lib-child-name
                          [name]="name.firstName"
                          [fontSize]="fontSizeFirstName"
                          context="firstName"
                          [ngStyle]="{
                            'height.px': config.value.childFirstNameHeight,
                          }"
                        ></lib-child-name>
                        <lib-child-name
                          [name]="name.lastName"
                          [fontSize]="fontSizeLastName"
                          [ngStyle]="{
                            'height.px': config.value.childLastNameHeight,
                          }"
                          context="name"
                        ></lib-child-name>
                      } @else {
                        <ng-template [ngTemplateOutlet]="joined"></ng-template>
                      }
                      <ng-template #joined>
                        <lib-child-name
                          [ngStyle]="{
                            'height.px': config.value.childFirstNameHeight,
                          }"
                          [name]="name.lastName + ' ' + name.firstName"
                          [fontSize]="fontSizeFirstName"
                          context="name"
                        ></lib-child-name>
                      </ng-template>
                    </div>
                  </div>
                </div>
              }
            }

            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="addPlaceHolder(name.index, 1)">
                Pełny
              </button>
              <button mat-menu-item (click)="addPlaceHolder(name.index, 0.5)">
                Połówkowy
              </button>
            </mat-menu>
          </ng-container>
        }
      </div>
    </div>
  }
</div>
<svg viewBox="0 0 180 100">
  <filter id="noise" x="0%" y="0%" width="100%" height="100%">
    <feTurbulence baseFrequency="0.01 0.4" result="NOISE" numOctaves="2" />
    <feDisplacementMap
      in="SourceGraphic"
      in2="NOISE"
      scale="20"
      xChannelSelector="R"
      yChannelSelector="R"
    ></feDisplacementMap>
  </filter>
</svg>
